// TODO: Move to `apps/seller/src/types`
export enum Permission {
    DASHBOARD_VIEW = "dashboard.view",
    DASHBOARD_SEARCH_VIEW = "dashboard.search.view",
    DASHBOARD_AVAILABILITY_VIEW = "dashboard.availability.view",
    MODIFY_EVENT = "modify_event.view",
    MODIFY_BOOKING = "modify_booking.view",
    MODIFY_BOOKING_LITE = "modify_booking_lite.view",
    ADD_BOOKING_VIEW = "add_booking.view",
    MODIFY_CAPACITY = "modify_capacity.view",
    ADD_EVENT_NOTE = "add_event.view",
    SEND_EVENT_MESSAGE = "send_event_message.view",
    MODIFY_NOTES = "edit_notes.view",
    GUEST_STATUS = "guest_status.view",
    EMAIL_ROSTER = "email_roster.view",
    REFUND_AMOUNT = "refund_amount.view",
    MODIFY_COUPONS = "modify_coupons.view",
    APPLY_COUPONS = "apply_coupons.view",
    MODIFY_PARTNERS = "modify_partners.view",
    MODIFY_TERMS_TEMPLATES = "modify_terms_templates.view",
    PURCHASES_VIEW = "purchases.view",
    CUSTOMERS_VIEW = "customers.view",
    CUSTOMERS_EXPORT = "customers.export",
    CONTACTS_VIEW = "contacts.view",
    MESSAGE_TEMPLATES_VIEW = "message_templates.view",
    NOTIFICATIONS_VIEW = "notifications.view",
    NOTIFICATIONS_DISMISS_VIEW = "notifications_dismiss.view",
    PRODUCTS_VIEW = "products.view",
    PRODUCT_CATALOG_VIEW = "product_catalog.view",
    GIFT_OFFERS_VIEW = "gift_offers.view",
    PACKAGES_VIEW = "packages.view",
    MEMBERSHIPS_VIEW = "memberships.view",
    MEMBERSHIPS_MODIFY = "memberships.modify",
    MERCHANDISE_VIEW = "merchandise.view",
    MERCHANDISE_MODIFY = "merchandise.modify",
    MERCHANDISE_PURCHASE_VIEW = "merchandise_purchase.view",
    NON_WARE_MANAGER_VIEW = "non_ware_manager.view",
    COMBOS_VIEW = "combos.view",
    PARTNER_EXPERIENCES_VIEW = "partner_experiences.view",
    PARTNER_PACKAGES_VIEW = "partner_packages.view",
    PARTNER_PACKAGES_MODIFY = "partner_packages.modify",
    PACKAGES_MODIFY = "packages.modify",
    VIEW_RESOURCES_EQUIPMENT = "view_equipment.view",
    MODIFY_RESOURCES_EQUIPMENT = "modify_equipments.view",
    MODIFY_EXPERIENCE_RESOURCES = "modify_experience_resources.view",
    MODIFY_EQUIPMENT_CAPACITY = "modify_equipment_capacity.view",
    MODIFY_EQUIPMENT_CAPACITY_BLACKOUT = "modify_equipment_capacity_blackout.view",
    VIEW_RESOURCES_GUIDE = "vide_guide.view",
    MODIFY_RESOURCES_GUIDE = "modify_guide.view",
    RESOURCES_GUIDES_ALL_VIEW = "resources.guides_all.view",
    RESOURCES_GUIDES_PARTIAL_VIEW = "resources.guides_partial.view",
    RESOURCES_EQUIPMENT_SETTINGS_VIEW = "resources.equipment_settings.view",
    TRANSACTIONS_VIEW = "transactions.view",
    REPORTS_VIEW = "reports.view",
    REPORTS_ANALYTICS_VIEW = "reports.analytics.view",
    REPORTS_CUSTOMERS_VIEW = "reports.customers.view",
    REPORTS_EARNINGS_VIEW = "reports.earnings.view",
    REPORTS_GIFT_OFFERS_VIEW = "reports.gift.offers.view",
    REPORTS_CUSTOM_REPORTS_VIEW = "reports.custom.reports.view",
    REPORTS_XOLABOT_VIEW = "reports.xolabot.view",
    REPORTS_TICKET_REDEMPTION_VIEW = "reports.ticket_redemption.view",
    RESOURCES_VIEW = "resources.view",
    WAITLISTS_VIEW = "waitlists.view",
    WAIVERS_VIEW = "waivers.view",
    WAIVERS_PERMISSIONS_VIEW = "waivers.permissions.view",
    AFFILIATES_VIEW = "affiliates.view",
    AFFILIATES_ACTIONS = "affiliates.actions",
    MARKETING_VIEW = "marketing.view",
    DISTRIBUTION_VIEW = "distribution.view",
    MESSAGE_DAY_RESERVATION_VIEW = "message.day.reservation.view",
    ABANDONED_VIEW = "abandoned.view",
    OPERATORS_VIEW = "operators.view",
    OPERATORS_ACTIONS = "operators.actions",
    AGENTS_TERMS_TEMPLATE_ACTIONS = "agents.terms.template.actions",
    DISTRIBUTION_PROFILE_VIEW = "distribution.profile.view",
    MARKETER_HOME_VIEW = "marketer_home.view",
    XSITE_VIEW = "xsite.view",
    EMBEDDED_CHECKOUT_VIEW = "embedded_checkout.view",
    MULTI_LANGUAGE_SUPPORT_VIEW = "languages.view",
    MULTI_LANGUAGE_SUPPORT_ADD_LANGUAGE = "languages.add_language.view",
    APP_STORE_VIEW = "app_store.view",
    X_RAY_VIEW = "x_ray.view",
    SETTINGS_VIEW = "settings.view",
    COMPANY_PROFILE_VIEW = "company_profile.view",
    COMPANY_BASIC_INFO_VIEW = "company_basic_info.view",
    BUTTON_CODE_VIEW = "button_code.view",
    ACCESS_MANAGER_VIEW = "access.manager.view",
    MODIFY_ACCESS_MANAGER_MAKE_OWNER = "access.manager.make_owner.view",
    MODIFY_ACCESS_MANAGER_REVOKE_ACCESS = "access.manager.revoke_access.view",
    NOTIFICATIONS_SETTINGS_VIEW = "notifications_settings.view",
    ACCOUNT_INFORMATION_VIEW = "account_information.view",
    ACCOUNT_LANGUAGES_VIEW = "account_languages.view",
    PREFERENCES_PURCHASES_VIEW = "preferences_purchases.view",
    PREFERENCES_SELLER_VIEW = "preferences_seller.view",
    PREFERENCES_ADMIN_VIEW = "preferences_admin.view",
    PREFERENCES_GIFT_VIEW = "preferences_gift.view",
    PREFERENCES_ROSTER_VIEW = "preferences_roster.view",
    PREFERENCES_KIOSK_VIEW = "preferences_kiosk.view",
    PREFERENCES_IN_APP_NOTIFICATIONS_VIEW = "preferences_in_app_notifications.view",
    TAXES_AND_FEES_VIEW = "taxes_and_fees.view",
    PAYMENTS_SETTINGS_VIEW = "payments_settings.view",
    HARDWARE_VIEW = "hardware.view",
    PAYMENT_TERMINAL_VIEW = "emv.view",
    EDIT_PAIR_PAYMENT_DEVICE = "edit_pair_payment_device.view",
    RECEIPT_PRINTING_VIEW = "pos.view",
    RECEIPT_PRINTING_ADVANCED_EDIT = "pos.advanced.edit",
    TICKET_PRINTING_VIEW = "tickets.view",
    TICKET_PRINTING_SELLER_VIEW = "tickets_seller.view",
    APPS_SETTINGS_VIEW = "apps_settings.view",
    RESEND_WAIVER_EMAIL = "resend_waiver_email.view",
    RESEND_GRATUITY_EMAIL = "resend_gratuity_email.view",
    PRINT_RECEIPT = "print_receipt.view",
    CONVERSION_TRACKING_VIEW = "conversion_tracking.view",
    CUSTOM_CONVERSION_TRACKING_VIEW = "custom_conversion_tracking.view",
    FACEBOOK_PIXEL_TRACKING_VIEW = "facebook_pixel_tracking.view",
    COUPONS_VIEW = "coupons.view",
    XOLABOT_VIEW = "xolabot.view",
    SMS_SEND = "send_sms.view",
    INVOICE_VIEW = "invoice.view",
    BALANCE_VIEW = "balance.view",
    MODIFY_ROSTERS_WAIVER_EXPORT_DATA = "modify_rosters_waiver_export_data.view",
    GRATUITY_SETTINGS_VIEW = "gratuity_settings.view",
    GRATUITY_VIEW = "gratuity.view",
    STORE_CREDIT_VIEW = "store_credit.view",
    MODIFY_CUSTOMER_DETAILS = "modify_customer_details.view",
    MODIFY_PARTNERS_TAX_AND_FEE_SETTING = "modify_partners_tax_and_fee_setting.view",
    VIEW_PARTNERS_TAX_AND_FEE_SETTING = "view_partners_tax_and_fee_setting.view",
    ALLOW_PAST_DATES = "allow_past_dates.view",
    PREFERENCES_ROSTER_AUTO_EXPAND_NOTES = "preferences_roster_auto_expand_notes.view",
    PREFERENCES_ROSTER_PRINT_NOTES = "preferences_roster_print_notes.view",
    PREFERENCES_SETTINGS_VIEW = "preferences_settings.view",
    WAIVER_TIMELINE_VIEW = "waiver_timeline.view",
    MODIFY_WAIVER_VIEW = "modify_waiver.view",
    SPLIT_PAYMENT_VIEW = "split_payment.view",
    REPORTS_AFFILIATE_COMMISSIONS_VIEW = "reports_affiliate_commissions_view",
    REPORTS_PAYOUTS_VIEW = "reports_payouts_view",
    MARKETING_MANAGE_CHILDREN_VIEW = "marketing_manage_children_view",
    QRCODE_VIEW = "qrcode_view",
    EDIT_REFUND_RESERVE = "edit_refund_reserve_view",
    EXPORT_TICKETS = "export_tickets.view",
    ADD_MULTI_FACTOR_AUTHENTICATION_VIEW = "add_multi_factor_authentication.view",
    USER_PROFILE_VIEW = "user_profile.view",
    AMOUNT_DUE_VIEW = "amount_due.view",
    DEMOGRAPHIC_LIST_VIEW = "demographic_list.view",
    VIRTUAL_MEETINGS_VIEW = "virtual_meetings.view",
    SEARCH_CUSTOMERS = "search_customers.view",
    TOP_UP_VIEW = "top_up.view",
    MODIFY_TAXES_AND_FEES = "modify_taxes_and_fees.view",
    PARTNERS_COMMERCIAL_TERMS_VIEW = "partners_commercial_terms.view",
    PARTNERS_PURCHASE_SETTINGS_VIEW = "partners_purchase_settings.view",
    AGENTS_EXPERIENCES_SETTINGS_VIEW = "agents_experiences_settings.view",
    MODIFY_PARTNERS_BIO = "modify_partners_bio.view",
    ROSTER_VIEW = "roster.view",
    GUIDE_PROFILE_VIEW = "guide_profile.view",
    TUTORIALS = "tutorials.view",
    MODIFY_GUEST_VIEW = "modify_guest.view",
    PURCHASE_TAGS_VIEW = "purchase_tags.view",
    MODIFY_PURCHASE_CONTACT_VIEW = "modify_purchase_contact_details.view",
    PURCHASE_NOTES_VIEW = "purchase_notes.view",
    PRODUCT_GLOBAL_SETTINGS_REVIEW_TAB_VIEW = "product_global_settings_review_tab.view",
    PRODUCT_GLOBAL_SETTINGS_DATEPICKER_TAB_VIEW = "product_global_settings_datepicker_tab.view",
    PRODUCT_GLOBAL_SETTINGS_EMAIL_FOOTER_TAB_VIEW = "product_global_settings_email_footer_tab.view",
    PRODUCT_GLOBAL_SETTINGS_CHECKIN_PREFERENCE_TAB_VIEW = "product_global_settings_checkIn_reference_tab.view",
    XOLA_ADMIN = "xola_admin",
    SERVER_SIDE_TRACKING_VIEW = "server_side_tracking.view",
    X2_CHECKOUT_VIEW = "x2_checkout.view",
    MODIFY_COLLECTIONS = "modify_collections.view",
    DISPUTE_REPORT_VIEW = "dispute_report.view",
    DISPUTE_CHALLENGE_VIEW = "dispute_challenge.view",
    CUSTOMERS_SETTINGS_VIEW = "customers_settings.view",
}
